import { useSeo } from "@/lib/seo";
import { Section, Overline } from "@/components/shared";
import { BookingEmbed } from "@/components/BookingEmbed";

export default function Book() {
  useSeo(
    "Book a Consultation | Systems Beyond",
    "Schedule a consultation with Systems Beyond to discuss your research model, aging biology question or business systems challenge."
  );
  return (
    <Section className="pt-36 pb-24 lg:pt-44" grid>
      <div className="max-w-3xl">
        <Overline>Book a consultation</Overline>
        <h1 className="mt-7 text-4xl lg:text-6xl tracking-tighter leading-[0.98] font-medium text-ink">Find a time that works.</h1>
        <p className="mt-7 text-base lg:text-lg text-dark-gray leading-relaxed">
          Choose a slot below and tell us what you're working on — a research question, a biological
          model, a business challenge, or a possible collaboration.
        </p>
        <div className="mt-10">
          <BookingEmbed title={null} />
        </div>
      </div>
    </Section>
  );
}
